/*! responsive.js | Adminuiux 2025 */

"use strict";

window.addEventListener('resize', () => {
    //console.log($(window).width())
})